import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {CAMPAIGNS_QUERY_KEY} from "../queryKeys";
import {CampaignRow} from "./types";

type Data = CampaignRow[];

const getCampaigns = async (): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/campaigns");
  return response.data;
};

export const useGetCampaigns = (options?: BaseQueryOptions<Data, void>): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, void>([CAMPAIGNS_QUERY_KEY], getCampaigns, undefined, options);
};
